<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <user-card>
          <div class="md-layout md-alignment-center-right" slot="footer">
            <md-button class="md-simple md-primary" :to="{
              name: 'Permisos de Usuario',
            }" v-if="$canView('auth', 'permission')">
              <md-icon> extension </md-icon>
              Permisos
            </md-button>
            <md-button class="md-simple md-success" v-hide-in-production v-if="$canView('auth', 'permission')" :to="{
              name: 'Permisos de Grupo',
            }">
              <md-icon> extension </md-icon>
              Permisos del Grupo
            </md-button>
            <md-button @click="clickHandler" class="md-simple md-dense lvl-button">
              <md-icon> face </md-icon>
            </md-button>
          </div>
        </user-card>
      </div>
    </div>
  </div>
</template>

<script>
import UserCard from "./UserProfileComponents/UserCard";
import UserPermissionsCard from "./UserProfileComponents/UserPermissionsCard";
import updateAccountLevel from '@/services/account/updateAccountLevel'

export default {
  components: {
    UserCard,
    UserPermissionsCard,
  },
  data() {
    return {
      inDevelopment: process.env.NODE_ENV !== "production",
    };
  },
  methods: {
    clickHandler() {
      const now = Date.now()
      if (now - this.specialLastClickTime > 2000) {
        this.specialClickCount = 1
      } else {
        this.specialClickCount++
      }
      this.specialLastClickTime = now

      if (this.specialClickCount >= 3) {
        this.specialClickCount = 0
        this.specialLastClickTime = 0
        updateAccountLevel()
          .then(r => this.$router.go())
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.text-right {
  display: flex;
}

.lvl-button {
  opacity: 0.1;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfile.vue